<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Rule') : $t('New Rule')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-text-field
              v-model="formValues.name"
              label="Name"
              v-validate="'required'"
              required
              data-vv-name="name"
              :error-messages="errors.collect('name')"
            ></v-text-field>
            <v-select
              v-model="formValues.dimension"
              :items="dimensions"
              label="Dimension"
              item-text="name"
              required
              data-vv-name="dimension"
              :error-messages="errors.collect('dimension')"
            ></v-select>
            <v-text-field
              v-model="formValues.dimension_min"
              type="number"
              label="Min dimension"
              v-validate="'required'"
              required
              data-vv-name="dimension_min"
              :error-messages="errors.collect('dimension_min')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.dimension_max"
              type="number"
              label="Max dimension"
              v-validate="'required'"
              required
              data-vv-name="dimension_max"
              :error-messages="errors.collect('dimension_max')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.other_dimension_reference_value"
              type="number"
              label="Other dimension reference value"
              v-validate="'required'"
              required
              data-vv-name="other_dimension_reference_value"
              :error-messages="
                errors.collect('other_dimension_reference_value')
              "
            ></v-text-field>
            <v-text-field
              v-model="formValues.divergence_percentage"
              type="number"
              label="Divergence percentage"
              v-validate="'required'"
              required
              data-vv-name="divergence_percentage"
              :error-messages="errors.collect('divergence_percentage')"
            ></v-text-field>
            <v-select
              v-model="formValues.door_type_id"
              :items="door_types"
              label="Door Type"
              item-text="name"
              item-value="text"
              required
              v-validate="'required'"
              data-vv-name="door_type_id"
              :error-messages="errors.collect('door_type_id')"
            ></v-select>
            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'rule.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem, fetchDoorTypes } from "../shared/services";
export default {
  name: "app-rule-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: ""
      },
      permissions: [],
      loading: true,
      dimensions: ["width", "height"],
      door_types: [],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ]
    };
  },
  mounted() {
    fetchDoorTypes().then(res => {
      this.door_types = res.data;
    });

    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "rule.index" });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
